import * as constants from './constants';

export const initialState = {
  loading: false,
  error: undefined,
  makes: [],
  models: [],
  selectedMakeId: 0, // какого производителя в models выбраны модели ?
  generations: [],
  selectedModelId: 0, // для какой модели выбраны поколения ?
  modifications: [],
  selectedGenerationId: 0, // для какой поколения выбраны модификации ?
  clientVehicles: [], // список авто клиента
  clientIdClientVehicles: '', // clientId того клиента, чьи авто в clientVehicles
  clientVehicle: {}, // одно конкретное авто клиента
  clientVehicleRequest: {}, // по какому авто данные  в clientVehicle

  // список найденных авто по номеру
  // так как api возвращает пустой массив, если номер авто не найден,
  // то используем null как индикатор того, что поиск в процессе или еще не производился
  foundVehicles: null,
  // если при поиске api вернул http ошибку, то используем для нее отдельный объект,
  // чтоб не было конфликтов с основным error
  foundVehiclesError: undefined,

  carmenMakes: [],
};

const vehiclesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_VEHICLE_MAKE_FAIL:
    case constants.FETCH_VEHICLE_MAKE_SUCCESS:
    case constants.FETCH_VEHICLE_MODEL_FAIL:
    case constants.FETCH_VEHICLE_MODEL_SUCCESS:
    case constants.FETCH_VEHICLE_GENERATION_FAIL:
    case constants.FETCH_VEHICLE_GENERATION_SUCCESS:
    case constants.FETCH_VEHICLE_MODIFICATION_FAIL:
    case constants.FETCH_VEHICLE_MODIFICATION_SUCCESS:
    case constants.FETCH_CLIENT_VEHICLES:
    case constants.FETCH_CLIENT_VEHICLES_SUCCESS:
    case constants.FETCH_CLIENT_VEHICLE:
    case constants.FETCH_CLIENT_VEHICLE_FAIL:
    case constants.FETCH_CLIENT_VEHICLE_SUCCESS:
    case constants.CREATE_CLIENT_VEHICLE:
    case constants.CREATE_CLIENT_VEHICLE_FAIL:
    case constants.CREATE_CLIENT_VEHICLE_SUCCESS:
    case constants.UPDATE_CLIENT_VEHICLE:
    case constants.UPDATE_CLIENT_VEHICLE_FAIL:
    case constants.UPDATE_CLIENT_VEHICLE_SUCCESS:
    case constants.MAKE_CLIENT_VEHICLE_PRIMARY:
    case constants.MAKE_CLIENT_VEHICLE_PRIMARY_FAIL:
    case constants.MAKE_CLIENT_VEHICLE_PRIMARY_SUCCESS:
    case constants.DELETE_CLIENT_VEHICLE_FAIL:
    case constants.DELETE_CLIENT_VEHICLE_SUCCESS:
    case constants.CLEAR_CLIENT_VEHICLES_SUCCESS:
    case constants.CLEAR_CLIENT_VEHICLE_SUCCESS:
    case constants.FIND_VEHICLE:
    case constants.FIND_VEHICLE_FAIL:
    case constants.FIND_VEHICLE_SUCCESS:
    case constants.CLEAR_FOUNDED_VEHICLE:
    case constants.ADD_VEHICLE_TO_CLIENT_FAIL:
    case constants.ADD_VEHICLE_TO_CLIENT_SUCCESS:
    case constants.GET_CARMEN_VEHICLE:
    case constants.GET_CARMEN_VEHICLE_FAIL:
    case constants.GET_CARMEN_VEHICLE_SUCCESS:
    case constants.UPDATE_CARMEN_VEHICLE_SUCCESS:
    case constants.UPDATE_CARMEN_VEHICLE_FAIL:
      return { ...state, ...action.payload };
    case constants.FETCH_CLIENT_VEHICLES_FAIL:
      return { ...state, ...action.payload, clientIdClientVehicles: undefined };
    default:
      return state;
  }
};

export default vehiclesReducer;
